import { createRoot } from 'react-dom/client';
import '@fontsource-variable/instrument-sans';
import { AppRouter } from './AppRouter.tsx';
import { installThemeBootstrap } from './theme.ts';
import './index.css';

// SEC-128: the access token now lives only in an HttpOnly cookie. Purge any
// token a pre-cookie-auth session left behind so JS can no longer read it.
try {
  localStorage.removeItem('inspect_ai_access_token');
} catch {
  // localStorage may be unavailable (private mode / sandboxed iframe); ignore.
}

installThemeBootstrap();
createRoot(document.getElementById('root')!).render(<AppRouter />);
